(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bl-related-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bl-related-bundle')) {
    customElements.define('bl-related-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.data = JSON.parse(this.querySelector('[data-bundle-data]').textContent);
        this.text = JSON.parse(this.querySelector('[data-bundle-text]').textContent);
        this.root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        this.button = this.querySelector('[data-pair-add]');
        this.select = this.querySelector('[data-pair-variant]');
        this.message = this.querySelector('[data-pair-message]');
        this.abort = new AbortController();
        this.select.addEventListener('change', () => { this.userSelected = true; this.update(); }, {signal:this.abort.signal});
        this.button.addEventListener('click', () => this.add(), {signal:this.abort.signal});
        this.scope = this.closest('product-info') || this.closest('.shopify-section');
        this.scope?.addEventListener('change', (event) => {
          if (event.target.closest('variant-selects')) this.selecting = true;
          if (event.target.name === 'id') { this.selecting = false; this.matchVariant(); }
          this.update();
        }, {signal:this.abort.signal});
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (String(event.data.sectionId) !== this.dataset.section) return;
            this.selecting = false;
            this.matchVariant();
            this.update();
          });
        }
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        }, {rootMargin:'400px'});
        this.observer.observe(this.scope || this);
      }
      disconnectedCallback() {
        this.abort?.abort(); this.observer?.disconnect(); this.unsubscribe?.(); this.initialized = false;
      }
      get form() { return document.getElementById('product-form-' + this.dataset.section); }
      get currentVariant() {
        const input = this.form?.querySelector('[name="id"]');
        const id = input ? input.value : this.dataset.selected;
        return this.data.current.variants.find(variant => String(variant.id) === String(id));
      }
      get suggestedVariant() { return this.suggestion?.variants.find(variant => String(variant.id) === this.select.value); }
      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency}).format(cents / 100);
      }
      rank(products) {
        const tags = this.data.current.tags || [];
        const seen = new Set();
        return products.filter(product => {
          if (!product || product.id === this.data.current.id || seen.has(product.id)) return false;
          seen.add(product.id);
          return (product.image || product.featured_image) && product.variants?.some(variant => variant.available && variant.price > 0);
        }).map((product, index) => ({product, score:(product.tags || []).reduce((score, tag) => score + (tags.includes(tag) ? (tag.startsWith('category_') ? 30 : 1) : 0), product.type === this.data.current.type ? 10 : 0), index}))
          .sort((a,b) => b.score - a.score || a.index - b.index).map(item => item.product);
      }
      async load() {
        let products = [];
        try {
          const response = await fetch(this.root + 'recommendations/products.json?product_id=' + this.data.current.id + '&limit=10&intent=related', {signal:AbortSignal.any([this.abort.signal, AbortSignal.timeout(6000)])});
          if (response.ok) products = (await response.json()).products || [];
        } catch (error) { if (this.abort.signal.aborted) return; }
        if (!this.isConnected) return;
        this.suggestion = this.rank(products)[0] || this.rank(this.data.fallback)[0];
        if (!this.suggestion) return;
        this.select.replaceChildren();
        this.suggestion.variants.filter(variant => variant.available && variant.price > 0).forEach(variant => {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title;
          this.select.append(option);
        });
        this.select.closest('label').hidden = this.select.options.length === 1 && this.suggestion.variants[0].title === 'Default Title';
        const url = new URL(this.suggestion.url || this.root + 'products/' + this.suggestion.handle, location.origin);
        if (url.origin !== location.origin) return;
        this.querySelector('[data-pair-link]').textContent = this.suggestion.title;
        this.querySelector('[data-pair-link]').href = url.href;
        this.querySelector('[data-pair-image-link]').href = url.href;
        const img = this.querySelector('[data-pair-image]');
        const image = this.suggestion.image || this.suggestion.featured_image;
        const imageURL = new URL(typeof image === 'string' ? image : image.src, location.origin);
        imageURL.searchParams.set('width','240');
        img.src = imageURL.href;
        this.matchVariant(); this.update(); this.hidden = false;
      }
      matchVariant() {
        if (!this.suggestion || this.userSelected) return;
        const current = this.currentVariant;
        const available = this.suggestion.variants.filter(variant => variant.available && variant.price > 0);
        const tags = this.data.current.tags || [];
        const studio = /finished piece|studio-made/i.test(current?.title || '') || (tags.includes('finished_piece') && !tags.includes('diy_kit'));
        const match = available.find(variant => variant.title === current?.title) || available.find(variant => studio ? /finished piece|studio-made/i.test(variant.title) : /diy kit/i.test(current?.title || '') && /diy kit/i.test(variant.title));
        if (match) this.select.value = String(match.id);
      }
      update() {
        if (!this.suggestion) return;
        const current = this.currentVariant;
        const suggested = this.suggestedVariant;
        const valid = current?.available && current.price > 0 && suggested?.available;
        this.button.disabled = !valid || this.busy || this.selecting || this.uncertain;
        this.button.textContent = this.busy ? this.text.adding : valid && !this.selecting ? this.text.add : this.text.unavailable;
        this.querySelector('[data-pair-price]').textContent = suggested ? this.money(suggested.price) : '';
        this.querySelector('[data-pair-original]').textContent = valid ? this.money(current.price + suggested.price) : '';
        this.querySelector('[data-pair-total]').textContent = valid ? this.money(Math.round(current.price * .95) + Math.round(suggested.price * .95)) : '';
      }
      async add() {
        if (this.button.disabled || this.busy) return;
        const current = this.currentVariant;
        const suggested = this.suggestedVariant;
        if (!current?.available || !suggested?.available || !this.form?.reportValidity()) return;
        const formData = new FormData(this.form);
        const properties = {};
        for (const [key,value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
          if (match && typeof value !== 'string' && value.size) { this.message.textContent = this.text.error; return; }
        }
        const items = [{id:current.id,quantity:1,properties}, {id:suggested.id,quantity:1}];
        if (formData.get('selling_plan')) { this.message.textContent = this.text.error; return; }
        this.busy = true; this.message.textContent = ''; this.update();
        let response;
        try {
          response = await fetch(this.root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
        } catch (error) {
          this.uncertain = true; this.busy = false;
          this.message.textContent = this.text.uncertain;
          this.querySelector('[data-pair-cart]').hidden = false; this.update(); return;
        }
        if (!response.ok) {
          let result = {}; try { result = await response.json(); } catch (error) {}
          this.busy = false; this.uncertain = true;
          this.message.textContent = result.description || this.text.error;
          this.querySelector('[data-pair-cart]').hidden = false; this.update(); return;
        }
        window.location.assign(this.root + 'cart');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
